import styled from 'styled-components';

const BodyWrap = styled.div`
    padding: 1.875rem 1.25rem 5rem 1.25rem;
    max-width: 30rem;
    margin: 0 auto;
    line-height: 1.375rem;
`;

export default BodyWrap;
